import { render } from "./ChangelogList.vue?vue&type=template&id=5494928c"
import script from "./ChangelogList.vue?vue&type=script&lang=js"
export * from "./ChangelogList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__